import { api } from '@shared/api';
import type { AnalyticsPeriod } from './adminAnalyticsApi';

// Журнал ошибок бэкенда (2026-10-13): ERROR+ из API и воркеров, без ожидаемых отказов 4xx.
// Ответ бэка приходит в snake_case (response-интерцептор), здесь — чистый camelCase.

export interface ErrorDay {
  /** YYYY-MM-DD, день по Москве. */
  day: string;
  /** null — учёт ещё не шёл. */
  count: number | null;
}

export interface ErrorPlace {
  /** «POST /api/v1/cards», «job generate_card_job» или модуль.функция. */
  place: string;
  errorType: string;
  count: number;
  lastAt: string | null;
  /** Файл:строка и функция последней такой ошибки. */
  origin: string | null;
  /** request_id последней (у задач — job_id): по нему искать в Kibana. */
  requestId: string | null;
  component: string | null;
  status: number | null;
}

export interface ErrorEvent {
  at: string;
  place: string;
  errorType: string;
  origin: string | null;
  status: number | null;
  requestId: string | null;
  component: string | null;
  level: string;
  message: string;
}

export interface AdminErrors {
  days: AnalyticsPeriod;
  generatedAt: string;
  /** С какого дня ведётся учёт; null — ещё не начат. */
  since: string | null;
  today: number;
  week: number;
  weekPrev: number;
  month: number;
  monthPrev: number;
  period: number;
  periodPrev: number;
  series: ErrorDay[];
  places: ErrorPlace[];
  recent: ErrorEvent[];
  kibanaUrl: string | null;
}

interface BackendPlace {
  place: string;
  error_type: string;
  count: number;
  last_at: string | null;
  origin: string | null;
  request_id: string | null;
  component: string | null;
  status: number | null;
}

interface BackendEvent {
  at: string;
  place: string;
  error_type: string;
  origin: string | null;
  status: number | null;
  request_id: string | null;
  component: string | null;
  level: string;
  message: string;
}

interface BackendErrors {
  days: AnalyticsPeriod;
  generated_at: string;
  since: string | null;
  today: number;
  week: number;
  week_prev: number;
  month: number;
  month_prev: number;
  period: number;
  period_prev: number;
  series: ErrorDay[];
  places: BackendPlace[];
  recent: BackendEvent[];
  kibana_url: string | null;
}

/** GET /api/v1/admin/errors?days= — счётчики, места и последние ошибки. Только для ADMIN. */
export async function fetchAdminErrors(days: AnalyticsPeriod): Promise<AdminErrors> {
  const { data } = await api.get<BackendErrors>('/admin/errors', { params: { days } });
  return {
    days: data.days,
    generatedAt: data.generated_at,
    since: data.since,
    today: data.today,
    week: data.week,
    weekPrev: data.week_prev,
    month: data.month,
    monthPrev: data.month_prev,
    period: data.period,
    periodPrev: data.period_prev,
    series: data.series,
    places: data.places.map((row) => ({
      place: row.place,
      errorType: row.error_type,
      count: row.count,
      lastAt: row.last_at,
      origin: row.origin,
      requestId: row.request_id,
      component: row.component,
      status: row.status,
    })),
    recent: data.recent.map((row) => ({
      at: row.at,
      place: row.place,
      errorType: row.error_type,
      origin: row.origin,
      status: row.status,
      requestId: row.request_id,
      component: row.component,
      level: row.level,
      message: row.message,
    })),
    kibanaUrl: data.kibana_url,
  };
}
